export const createKeyboardShortcut = ({
    tabIndex = 0,
    onKeyDown = () => { },
    keys = ["Enter", "Spacebar", " "],
    dropDownNavigation = false,
    dropDownFocus = false,
}) => ({
    tabIndex,
    onKeyDown: (event) => {
        if (dropDownFocus === true && ["ArrowDown"].includes(event.key)) {
            // Use down arrow to select the first option of an open drop down menu (When focus is on the button)
            const dropDownMenu = event.target.parentElement.children[1];
            const firstOption = dropDownMenu.getElementsByTagName("li")[0];

            event.preventDefault();
            firstOption?.focus();
            
            return;
        }

        if (dropDownNavigation && ["ArrowDown", "ArrowUp"].includes(event.key)) {
            // Navigate through the drop down menu with the up and down arrow keys
            const options = event.target.parentElement.children;
            const index = Object.values(options).indexOf(event.target);

            const nextIndex = event.key === "ArrowDown" ? index + 1 : index - 1;

            event.preventDefault();
            options[nextIndex]?.focus();

            return;
        }

        if (!keys.includes(event.key)) return;
        if (event.target !== event.currentTarget) return; // prevent the event from bubbling up to the parent element

        event.preventDefault();
        onKeyDown(event);
    },
});